import { t } from "i18next";

export class OutcomeClassService {
  static getOutcomeClasses = () => {
    return Promise.resolve().then(() => {
      return [
        { name: t("review.new"), id: "new" },
        { name: t("review.private"), id: "private" },
        { name: t("review.variant"), id: "variant" },
        { name: t("review.version"), id: "version" },
      ];
    });
  };
}
